import { motion } from "framer-motion";
import { LogoFull } from "./Logo";
import { EASE, SOFT } from "./Motion";

export const Loader = () => (
  <motion.div
    data-testid="intro-loader"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0D0D0F] text-[#FFF4E8]"
    initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
    exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
    transition={{ duration: 0.95, ease: EASE }}
  >
    <motion.div
      initial={{ scale: 0.6, y: 40, opacity: 0 }}
      animate={{ scale: 1, y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: SOFT }}
      className="px-6"
    >
      <LogoFull className="w-[min(82vw,560px)] h-auto drop-shadow-[0_30px_60px_rgba(255,85,0,0.45)]" />
    </motion.div>
    <div className="overflow-hidden mt-6">
      <motion.p
        className="text-xs uppercase tracking-[0.35em] font-semibold text-[#FF8844]"
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ delay: 0.35, duration: 0.8, ease: EASE }}
      >
        Passione per lo spiedo dal 1998
      </motion.p>
    </div>
    <div className="absolute bottom-10 left-6 right-6 sm:left-16 sm:right-16 h-[3px] bg-white/10 overflow-hidden rounded-full">
      <motion.div
        className="h-full bg-[#FF5500] origin-left"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.6, ease: SOFT }}
      />
    </div>
  </motion.div>
);
